import axios from "axios";
import { BASE_URL as URL } from "./config"; // Ensure you create and export BASE_URL in this file

// Setup axios interceptor for authentication
axios.interceptors.request.use(
  (config) => {
    // Automatically add Authorization header if token exists
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      // Only redirect to login if not already on auth pages
      const currentPath = window.location.pathname;
      if (!["/login", "/register"].includes(currentPath)) {
        window.location.href = "/login"; // Redirect to login page
      }
    }
    return Promise.reject(error);
  }
);

const apiRequest =
  (BASE_URL, method = "GET") =>
  async (urlSuffix, data = null, headers = {}) => {
    try {
      console.log(`${method} ${BASE_URL}${urlSuffix}`);
      const response = await axios({
        method,
        url: `${BASE_URL}${urlSuffix}`,
        data,
        headers: {
          ...headers,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("API Request Error:", error);
      throw error;
    }
  };

const API_CONSTRUCTOR = (BASE_URL = URL) => {
  return {
    get: apiRequest(BASE_URL, "GET"),
    post: apiRequest(BASE_URL, "POST"),
    put: apiRequest(BASE_URL, "PUT"),
    patch: apiRequest(BASE_URL, "PATCH"),
    delete: apiRequest(BASE_URL, "DELETE"),
  };
};

export default API_CONSTRUCTOR;
